import { Fragment } from 'react';

import * as Styled from '../../../../components/DealerPage/components/Listings/Listings.styled';

import type { ListingsProps } from '../../../../components/DealerPage/components/Listings/Listings.typed';

import { SearchCard } from '../../../../components/DealerPage/components/Listings/components/SearchCard/SearchCard';
import { SkeletonSearchCard } from '../../../../components/DealerPage/components/Listings/components/SkeletonSearhCard/SkeletonSearchCard';

function Listings(props: ListingsProps) {
  const {
    listings,
    viewType,
    currentSection,
    isLoading = false,
    createSavedAdEvent,
    deleteSavedAdEvent,
    extra,
  } = props;

  const isGrid = viewType === 'grid';

  const SKELETON_SEARCH_CARD_LIST_LENGTH = 15;

  return (
    <Styled.List data-testid="card-list" viewType={viewType}>
      {isLoading &&
        Array.apply(null, Array(SKELETON_SEARCH_CARD_LIST_LENGTH)).map(
          (_item: unknown, index: number) => {
            return (
              <SkeletonSearchCard
                key={`skeleton-search-card-${index}`}
                isGrid={isGrid}
              />
            );
          },
        )}
      {!isLoading &&
        listings.map((item, index) => (
          <Fragment
            key={item.spotlight ? `spotlight-${item.id}` : `${item.id}`}
          >
            {extra &&
              extra.length &&
              extra(index).map((item, index) => (
                <Fragment key={index}>{item}</Fragment>
              ))}
            <Styled.ListItem data-testid={`listing-card-index-${index}`}>
              <SearchCard
                item={item}
                isGrid={isGrid}
                currentSection={currentSection}
                createSavedAdEvent={createSavedAdEvent}
                deleteSavedAdEvent={deleteSavedAdEvent}
              />
            </Styled.ListItem>
          </Fragment>
        ))}
    </Styled.List>
  );
}

export { Listings };
